/* Bad Earl — smooth inertia scrolling (Lenis) */
(function () {
  if (typeof Lenis === 'undefined') return;

  // The theme editor drives its own scrolling when you select a section, and
  // hijacked wheel handling fights it.
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var lenis = new Lenis({
    lerp: 0.09,
    wheelMultiplier: 1,
    touchMultiplier: 1.8,
    smoothWheel: true,
    autoRaf: false
  });

  var rafId = 0;

  function raf(time) {
    if (document.hidden) {
      rafId = 0;
      return;
    }
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  }
  rafId = requestAnimationFrame(raf);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = 0;
    } else if (!rafId) {
      rafId = requestAnimationFrame(raf);
    }
  });

  window.beLenis = lenis;

  // In-page anchors have to go through Lenis or they fight the animation loop.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link) return;

    var id = link.getAttribute('href');
    if (!id || id === '#' || link.hasAttribute('data-lenis-ignore')) return;

    var target = document.querySelector(id);
    if (!target) return;

    event.preventDefault();
    lenis.scrollTo(target, { offset: -20 });
  });

  // Drawers and modals scroll internally; let the browser own those.
  document.querySelectorAll('.drawer__inner, .cart-drawer, .menu-drawer').forEach(function (el) {
    el.setAttribute('data-lenis-prevent', '');
  });

  // Dawn locks the page while drawers and modals are open, using either
  // overflow-hidden or overflow-hidden-<breakpoint> on the body.
  var body = document.body;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      var locked = Array.prototype.some.call(body.classList, function (name) {
        return name.indexOf('overflow-hidden') === 0;
      });

      if (locked) {
        lenis.stop();
      } else {
        lenis.start();
      }
    }).observe(body, { attributes: true, attributeFilter: ['class'] });
  }
})();
